exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swipe-modal-takumaru-vue-swipe-modal .modal-background{width:100%;height:100%}", ""]);

// exports
